<template>
    <div class="board_list">
        <ul v-if="data.list.length > 0">
            <template v-for="post in data.list || data" :key="post.idx">
                <li
                    @click="moveToPost(post)"
                    @keydown.enter="moveToPost(post)"
                    @keydown.space.prevent="moveToPost(post)"
                    role="button"
                    tabindex="0"
                >
                    <div class="col title">
                        <span class="category">[{{ post.secondCategoryName.trim() }}]</span>
                        <span v-if="post.filePath" class="attack-icon">
                            <img src="@/assets/ic-attach.png" alt="" />
                        </span>
                        <span class="post-title">{{ post.title || post.subject }}</span>
                        <span v-if="post.passwordYn === 'Y'" class="secret-icon">
                            <img src="@/assets/ic-secret.png" alt="" />
                        </span>
                    </div>
                    <div class="col writer" v-if="post.writer && data.noWriter">
                        <span>{{ post.writer }}</span>
                    </div>
                    <div class="col last" v-if="post.writeDate">
                        <span class="date">
                            {{ post.date?.toLocaleDateString('ko-KR') || new Date(post.writeDate).toLocaleDateString('ko-KR') }}
                        </span>
                    </div>
                </li>
            </template>
        </ul>
        <p class="no-data" v-else>등록된 게시글이 없습니다.</p>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            default: [],
        },
        modalOpen: {},
    },
    data() {
        return {
            path: this.$route.path,
        };
    },
    methods: {
        moveToPost(post) {
            if (!post?.idx) return;

            if (post.passwordYn === 'Y') {
                this.modalOpen(post.idx);
                return;
            }

            this.$router.push({
                path: `${this.path}/${post.idx}`,
                query: this.$route.query,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.board_list {
    width: 100%;
    border-top: 1px solid var(--black1);

    ul {
        width: 100%;

        li {
            list-style: none;
            width: 100%;
            height: 90px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid var(--border-color1);
            cursor: pointer;

            @media screen and (max-width: 768px) {
                flex-wrap: wrap;
                align-items: flex-start;
                height: auto;
                justify-content: flex-start;
                gap: 10px;
                padding-top: 25px;
                padding-bottom: 25px;
            }

            &:hover {
                background: #fffbf8;

                .post-title {
                    color: var(--orange);
                    text-decoration: underline;
                }
            }

            .col {
                &.title {
                    padding-left: 50px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    @media screen and (max-width: 768px) {
                        flex: 1 0 auto;
                        margin-right: 0;
                        padding-left: 20px;
                        padding-right: 20px;
                        width: 100%;
                    }

                    .secret-icon {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex: 0 0 auto;
                        width: 15px;
                        height: 15px;
                    }

                    .post-title {
                        font-size: 18px;
                        color: var(--black1);
                        letter-spacing: -0.03em;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        word-break: break-all;

                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }

                    .category {
                        font-size: 18px;
                        color: var(--orange);

                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }

                    .attack-icon {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex: none;
                    }
                }

                &.last {
                    flex-shrink: 0;
                    margin-left: auto;
                    width: 200px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    @media screen and (max-width: 768px) {
                        width: auto;
                        padding-right: 20px;
                        flex: none;
                        margin-left: 0;
                        padding-left: 20px;
                        height: auto;
                    }

                    .date {
                        font-size: 16px;
                        color: #888;
                    }
                }
            }
        }
    }
}

.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    color: #666;
}
</style>
